import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { memo } from "react";
import { Tooltip } from "../../Tooltip/index.js";
import { Button } from "../../Button/index.js";
import { useFilesService } from "../../services/hooks/index.js";
import { Box } from "../../Box/index.js";
import { Counter } from "../../Counter/index.js";
import { Paper } from "../../Paper/index.js";
import { FilePreview } from "../../FilePreview/index.js";
import { Icon } from "../../Icon/index.js";
import { Typography } from "../../Typography/index.js";
import { EllipsisText } from "../../EllipsisText/index.js";
import MultipleFileInput_styles from "./MultipleFileInput.styles.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const MultipleFileInputPreview_MultipleFileInputPreview = /*#__PURE__*/ memo(function(t0) {
    const $ = c(28);
    const { file, index, removeDocument, disabled, withAuth, withCounter: t1 } = t0;
    const withCounter = void 0 === t1 ? true : t1;
    const { classes } = MultipleFileInput_styles();
    const filesService = useFilesService();
    let t2;
    if ($[0] !== file.source || $[1] !== filesService || $[2] !== withAuth) {
        t2 = ()=>_async_to_generator(function*() {
                if ("string" != typeof file.source) return file.source;
                {
                    const fileData = yield filesService.getFile(file.source, withAuth);
                    const loadedFile = yield fileData.file;
                    return loadedFile;
                }
            })();
        $[0] = file.source;
        $[1] = filesService;
        $[2] = withAuth;
        $[3] = t2;
    } else t2 = $[3];
    const load = t2;
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            xs: 92,
            sm: 140
        };
        t4 = {
            xs: 92,
            sm: 140
        };
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    let t5;
    if ($[6] !== index || $[7] !== withCounter) {
        t5 = withCounter && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: 10,
            left: 10,
            radius: "round",
            height: 20,
            width: 20,
            zIndex: 1,
            children: /*#__PURE__*/ jsx(Counter, {
                backgroundColor: "gray",
                counter: index + 1
            })
        });
        $[6] = index;
        $[7] = withCounter;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== disabled || $[10] !== removeDocument) {
        t6 = !disabled && /*#__PURE__*/ jsx(Box, {
            position: "absolute",
            top: 7,
            right: 8,
            zIndex: 1,
            children: /*#__PURE__*/ jsx(Button, {
                size: "extraSmall",
                variant: "quaternaryAccent",
                onClick: removeDocument,
                icon: /*#__PURE__*/ jsx(Icon, {
                    name: "cancel",
                    size: "16",
                    color: "original.brand.primary"
                })
            })
        });
        $[9] = disabled;
        $[10] = removeDocument;
        $[11] = t6;
    } else t6 = $[11];
    const t7 = "string" != typeof file.source && file.source.name || "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F";
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            xs: "2",
            md: "4"
        };
        $[12] = t8;
    } else t8 = $[12];
    const t9 = "string" != typeof file.source && file.source.name || "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F";
    let t10;
    if ($[13] !== t9) {
        t10 = /*#__PURE__*/ jsx(Box, {
            position: "absolute",
            bottom: 1,
            right: 1,
            zIndex: 1,
            left: 1,
            bgcolor: "bg.greyscale.primary",
            py: t8,
            px: "12",
            borderBottomLeftRadius: "l",
            borderBottomRightRadius: "l",
            children: /*#__PURE__*/ jsx(EllipsisText, {
                rows: 1,
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "caption",
                    children: t9
                })
            })
        });
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== t10 || $[16] !== t7) {
        t11 = /*#__PURE__*/ jsx(Tooltip, {
            title: t7,
            placement: "bottom",
            children: t10
        });
        $[15] = t10;
        $[16] = t7;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== load) {
        t12 = /*#__PURE__*/ jsx(FilePreview, {
            onLoad: load,
            clickable: true
        });
        $[18] = load;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== classes.filePreviewPaper || $[21] !== t12) {
        t13 = /*#__PURE__*/ jsx(Paper, {
            className: classes.filePreviewPaper,
            children: t12
        });
        $[20] = classes.filePreviewPaper;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t11 || $[24] !== t13 || $[25] !== t5 || $[26] !== t6) {
        t14 = /*#__PURE__*/ jsxs(Box, {
            position: "relative",
            width: t3,
            height: t4,
            children: [
                t5,
                t6,
                t11,
                t13
            ]
        });
        $[23] = t11;
        $[24] = t13;
        $[25] = t5;
        $[26] = t6;
        $[27] = t14;
    } else t14 = $[27];
    return t14;
});
export { MultipleFileInputPreview_MultipleFileInputPreview as MultipleFileInputPreview };
